// extracted by mini-css-extract-plugin
module.exports = {"list":"EntitysList_list__1_ngZ","button":"EntitysList_button__mRfo1","checkboxPlaceholder":"EntitysList_checkboxPlaceholder__2b1L5","checkbox":"EntitysList_checkbox__1h0PF"};